module.exports = __webpack_public_path__ + "static/media/98.fa59de87.png";